import indigo from "@material-ui/core/colors/indigo";
import cyan from "@material-ui/core/colors/cyan";

export default {
    palette: {
        primary: {
            light: indigo[300],
            main: indigo[500],
            dark: indigo[700],
            contrastText: '#fff'
        },
        secondary: {
            light: cyan[300],
            main: cyan[200],
            dark: cyan[700],
            contrastText: '#fff'
        }
    },
    status: {
        danger: 'orange',
    },
    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        },
    },
};
